import { Field, TextOutput } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsEnIsoPlasticLimitStandalonePlasticLimitSection, BsEnIsoPreparationSection } from './Sections';

const qestIds = [ids.atterbergLimit.BS_EN_ISO_17892_12_2018.plastic_limit_standalone];

let AtterbergLimitPlasticLimitStandalone: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <BsEnIsoPreparationSection />
      </PageSection>
      <PageSection heading="Plastic Limit">
        <BsEnIsoPlasticLimitStandalonePlasticLimitSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <ListFieldSection>
          <Field input={<TextOutput />} name="Results.PlasticLimitText" />
        </ListFieldSection>
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AtterbergLimitPlasticLimitStandalone.qestIds = qestIds;

export default AtterbergLimitPlasticLimitStandalone;
